'use client';

import { Eye, ShieldCheck } from 'lucide-react';
import { useViewCount } from '../context/ViewCountContext';

export default function VisitorCounter({ className = '' }: { className?: string }) {
  const data = useViewCount();

  if (!data || !data.isAdmin || data.count === null) {
    return null;
  }

  return (
    <div
      className={`inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-sand/25 bg-sand/10 text-xs font-mono text-parchment shadow-warm backdrop-blur-md transition-all duration-300 ${className}`}
      title="Admin Mode: Confidential Page Views"
    >
      <ShieldCheck size={14} className="text-sand" />
      <Eye size={13} className="text-sand/70" />
      <span>
        Admin views: <strong className="text-sand font-700">{data.count.toLocaleString()}</strong>
      </span>
    </div>
  );
}
